import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * Editing now lives in the permission-aware user detail page. Keeping this
 * redirect preserves old bookmarks without retaining the legacy, invalid PUT
 * payload.
 */
export default function EditUser() {
  const { id } = useParams<{ id: string }>();

  return (
    <Navigate
      replace
      to={id ? `/users/${encodeURIComponent(id)}` : "/users"}
    />
  );
}
